module.exports = {"attributes":{"viewBox":"0 0 14 14"},"content":"<defs>     <path id=\"a\" d=\"M0 0h14v14H0z\"/>   </defs>   <g fill=\"none\" fill-rule=\"evenodd\">     <mask id=\"b\" fill=\"#fff\">       <use xlink:href=\"#a\"/>     </mask>     <path fill=\"#0F88EB\" d=\"M9 7.2l.5 2.8L7 8.7 4.5 10 5 7.2l-2-2L5.8 5 7 2.4l1.2 2.5 2.8.4-2 2zm3.5 1.9c.4-.9.7-1.9.7-3a6.2 6.2 0 1 0-11.7 3L0 12.4h2.1L3.4 14l1-2.2a6.1 6.1 0 0 0 5.2 0l1 2.2 1.3-1.7 2.1.1-1.5-3.3z\" mask=\"url(#b)\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-reward.svg
// module id = 627
// module chunks = 0